export default "__VITE_ASSET__DBP2F250__";